import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "td__hub-status" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "td__distributor-name" };
const _hoisted_4 = { class: "td__hub-name" };
const _hoisted_5 = { class: "td__share-delay-second" };
const _hoisted_6 = { class: "td__fee-rate" };
const _hoisted_7 = { class: "td__worker-fee-rate" };
const _hoisted_8 = { class: "td__store-fee-rate" };
const _hoisted_9 = { class: "td__store-management-fee-rate" };
const _hoisted_10 = { class: "td__is-displayed-on-order" };
const _hoisted_11 = { class: "td__share-config" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _directive_tr_highlight = _resolveDirective("tr-highlight");
    return _withDirectives((_openBlock(), _createElementBlock("tr", {
        "data-cy": "hub-shares-list-table-row",
        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.handleClickRow(_ctx.item.hubId, _ctx.item.hubName)))
    }, [
        _createElementVNode("td", _hoisted_1, [
            _createElementVNode("img", { src: _ctx.hubStatusImgPath }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _createElementVNode("td", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.validatedDistributorName), 1 /* TEXT */)
        ]),
        _createElementVNode("td", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.validatedHubName), 1 /* TEXT */)
        ]),
        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formattedShareDelaySecond), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formattedFeeRate), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formattedWorkerFeeRate), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formattedStoreFeeRate), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.formattedStoreManagementFeeRate), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formattedIsDisplayedOnOrder), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_11, [
            (!_ctx.isAvailableShareConfig)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    title: "공유설정불가",
                    icon: "mdi-pencil-off-outline",
                    variant: "text",
                    density: "comfortable",
                    disabled: !_ctx.isAvailableShareConfig
                }, null, 8 /* PROPS */, ["disabled"]))
                : (_ctx.shareConfigButtonInfo.isConfigBefore)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        title: "공유설정수정",
                        "data-cy": "share-config-button",
                        icon: "mdi-pencil-outline",
                        variant: "text",
                        density: "comfortable",
                        disabled: !_ctx.isAvailableShareConfig,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleClickShareConfig(_ctx.item.hubId)))
                    }, null, 8 /* PROPS */, ["disabled"]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        title: "공유설정추가",
                        icon: "mdi-plus",
                        variant: "text",
                        density: "comfortable",
                        disabled: !_ctx.isAvailableShareConfig,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.handleClickShareConfig(_ctx.item.hubId)))
                    }, null, 8 /* PROPS */, ["disabled"]))
        ])
    ])), [
        [_directive_tr_highlight, _ctx.isHighlight]
    ]);
}
